import React from 'react';
import CustomIcon from '../../Common/CustomIcon/CustomIcon';
import { copyTextToClipboard } from '../utils/pwa';

const buttonStyle = {
	display:    'inline-flex',
	alignItems: 'center',
	padding:    0,
	border:     'none',
	background: 'none',
	cursor:     'pointer',
	font:       'inherit',
	color:      '#0056b3',
};

const PWACopyURLButton = ({ url, showLabel = true }) => {
	const [ copyState, setCopyState ] = React.useState('idle');
	const resetTimeoutRef = React.useRef(null);
	const mountedRef = React.useRef(true);

	React.useEffect(() => {
		mountedRef.current = true;
		return () => {
			mountedRef.current = false;
			clearTimeout(resetTimeoutRef.current);
		};
	}, []);

	const showState = (state) => {
		// the clipboard can settle after the modal/row unmounts
		if (!mountedRef.current) {
			return;
		}
		setCopyState(state);
		clearTimeout(resetTimeoutRef.current);
		resetTimeoutRef.current = setTimeout(() => setCopyState('idle'), 2000);
	};

	let label = 'Copy URL';
	if (copyState === 'copied') {
		label = 'Copied';
	} else if (copyState === 'failed') {
		label = 'Copy failed';
	}

	return (
		<button
			type="button"
			title={url}
			aria-label={showLabel ? undefined : 'Copy PWA URL'}
			data-test-id="pwaCopyURL"
			style={buttonStyle}
			onClick={(e) => {
				e.preventDefault();
				// rows open the system modal on click
				e.stopPropagation();
				copyTextToClipboard(url)
					.then(() => showState('copied'))
					.catch(() => showState('failed'));
			}}
		>
			<CustomIcon icon="link" />
			{(showLabel || copyState !== 'idle') && (
				<span style={{ marginLeft: '5px', textDecoration: 'underline' }} aria-live="polite">{label}</span>
			)}
		</button>
	);
};

export default PWACopyURLButton;
